<div ngxUiLoaderBlurred>
    <mat-toolbar color="primary" class="example-toolbar app-topbar" *ngIf="user">
        <div class="m-0 d-flex align-items-center">
            <div class="logo-top bg-blue mr-2">
                <img routerLink="/firstpage" src="{{logotheme}}" onerror="this.src='assets/images/logo.png'" />
                <!-- <img routerLink="/firstpage" src="{{cds?.userimage}}" onerror="this.src='assets/images/logo.webp'" style="width: auto;height:30px; max-width:150px; cursor: pointer;" /> -->
            </div>
            <!-- <button mat-icon-button (click)="isExpanded = !isExpanded">
				<mat-icon>menu</mat-icon>
			</button> -->
        </div>
        <div *ngIf="user" class="app-topnav">
            <nav class="navbar navbar-expand-lg mv-list-show p-0">
                <div class="container-fluid p-0">
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="app-topnav-list">
                            <li class="nav-item">
                                <div class="top-nav-bg squirBox" routerLinkActive="squirActive active-menu"
                                    routerLink="/master/inventory-one-way"><i class="fa fa-plane"></i><span>Inventory</span></div>
                            </li>

                            <!-- <li class="nav-item"> -->
                            <!-- <li class="nav-item" *ngIf="wesiteThemeData.is_bulk == 1">
                                <div class="col- mr-2 squirBox" routerLinkActive="squirActive" routerLink="/master/bulk-inventory" style="width: 85px"><i class="fa fa-plane"> </i> <i class="fa fa-plane"></i> <span
                                    class="text-center ">Bulk Inventory</span>
                                </div>
                            </li> -->
                            <!-- <li class="nav-item">
                                <div class="col- mr-2 top-nav-bg squirBox" routerLinkActive="squirActive active-menu"
                                    routerLink="/dashboard/accounting/sale"><i class="fa fa-tag"></i>
                                    <span class="text-center">Sale</span>
                                </div>
                            </li> -->
                            <!-- <li class="nav-item">
                                <div class="col- mr-2 top-nav-bg squirBox" routerLinkActive="squirActive active-menu"
                                    routerLink="/dashboard/myapi-balance"><i class="fa fa-bank"></i>
                                    <span class="text-center">My Account</span>
                                </div>
                            </li> -->

                            <li class="nav-item dropdown" (mouseenter)="openMenu('sales')" (mouseleave)="closeMenu()"
                                (click)="toggleMenu('sales', $event)" [ngClass]="{ 'show': activeMenu === 'sales', 'active': isSalesActive() }">
                                <a class="nav-link lh-1 top-nav-bg"
                                    [ngClass]="{ 'active-menu': activeMenu === 'sales' || isSalesActive() }"
                                    [attr.aria-expanded]="activeMenu === 'sales'">
                                    <i class="fa fa-list-alt"></i><span>Sale List </span>
                                </a>
                                <ul class="dropdown-menu navbar-dropdown-caret"
                                    [ngClass]="{ 'show': activeMenu === 'sales' }">
                                    <li>
                                        <a class="nav-link" href="javascript:void(0);" routerLink="/common-sales-list"
                                            routerLinkActive="squirActive active" (click)="closeSidebarOnMobile()">
                                            <i class="fa fa-plane" aria-hidden="true"></i>
                                            <span> Sale List</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="nav-link" href="javascript:void(0);"
                                            routerLink="/dashboard/accounting/sale" routerLinkActive="squirActive active"
                                            (click)="closeSidebarOnMobile()">
                                            <i class="fa fa-tag" aria-hidden="true"></i>
                                            <span>Old Sale List</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown" (mouseenter)="openMenu('account')" (mouseleave)="closeMenu()"
                                (click)="toggleMenu('account', $event)"
                                [ngClass]="{ 'show': activeMenu === 'account', 'active': isAccountActive() }">
                                <a class="nav-link lh-1 top-nav-bg"
                                    [ngClass]="{ 'active-menu': activeMenu === 'account' || isAccountActive() }"
                                    [attr.aria-expanded]="activeMenu === 'account'">
                                    <i class="fa fa-user-o"></i><span>Account List </span>
                                </a>
                                <ul class="dropdown-menu navbar-dropdown-caret"
                                    [ngClass]="{ 'show': activeMenu === 'account' }">
                                    <li>
                                        <a class="nav-link" href="javascript:void(0);" routerLink="/common-account-list"
                                            routerLinkActive="squirActive active" (click)="closeSidebarOnMobile()">
                                            <i class="fa fa-file-text" aria-hidden="true"></i>
                                            <span> Account List</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="nav-link" href="javascript:void(0);"
                                            routerLink="/dashboard/myapi-balance" routerLinkActive="squirActive active"
                                            (click)="closeSidebarOnMobile()">
                                            <i class="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Old Account List</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>



                        </ul>
                    </div>
                </div>
            </nav>


        </div>

        <div class="user-profile-area">
            <div class="d-flex align-items-center">
                <button type="button" class="theme-switch mr-3" (click)="toggleTheme()"
                    [attr.aria-label]="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'">
                    <i class="fa" [ngClass]="isDarkTheme ? 'fa-sun-o' : 'fa-moon-o'"></i>
                </button>
                <button type="button" class="profile-trigger" [matMenuTriggerFor]="menu">
                    <span class="profile-avatar"><i class="fa fa-user"></i></span>
                    <span class="company-name-text mv-list-show" *ngIf="innerWidth > 500">{{user?.company_name}}</span>
                    <i class="fa fa-chevron-down profile-chevron"></i>
                </button>
            </div>
            <mat-menu #menu="matMenu" class="profile-dropdown">
                <div class="profile-menu">
                    <!-- Company info in mobile -->
                    <div class="profile-menu-header mv-list-hide">
                        <p class="menu-company-name">{{user?.company_name}}</p>
                        <p class="menu-email">{{user?.email}}</p>
                    </div>

                    <!-- Mobile nav items -->
                    <button mat-menu-item *ngIf="innerWidth < 500 && wesiteThemeData.is_bulk == 1"
                        routerLink="/master/bulk-inventory">
                        <i class="fa fa-plane menu-icon"></i>
                        <span>Bulk Inventory</span>
                    </button>
                    <button mat-menu-item *ngIf="innerWidth < 500" routerLink="/master/inventory-one-way">
                        <i class="fa fa-plane menu-icon"></i>
                        <span>Inventory</span>
                    </button>
                    <button mat-menu-item *ngIf="innerWidth < 500" routerLink="/common-sales-list">
                        <i class="fa fa-tag menu-icon"></i>
                        <span>Sale</span>
                    </button>
                    <button mat-menu-item *ngIf="innerWidth < 500" routerLink="/common-account-list">
                        <i class="fa fa-bank menu-icon"></i>
                        <span>My Account</span>
                    </button>

                    <!-- Always visible -->
                    <button mat-menu-item routerLink="/dashboard/viewprofile">
                        <i class="fa fa-user menu-icon"></i>
                        <span>Profile</span>
                    </button>
                    <button mat-menu-item (click)="logout()">
                        <i class="fa fa-power-off menu-icon"></i>
                        <span>Logout</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </mat-toolbar>


    <!-- <mat-sidenav-container class="example-container" autosize style="background-image: url('assets/images/dashboard_bg.webp');background-repeat: no-repeat;background-size: cover;"> -->
    <mat-sidenav-container class="example-container" autosize>
        <!-- <mat-sidenav #sidenav class="example-sidenav secondToolbar" mode="side" opened="true"
			(mouseenter)="mouseenter()" (mouseleave)="mouseleave()"
			[ngClass]="{'mat-elevation-z5' : true, 'sticky' : isSticky}" [disableClose]="true" *ngIf="router.url!='/firstpage'">
			<mat-nav-list style="margin-bottom:40px;">
				<mat-list-item class="mt-1 position-relative">
					<span class="full-width" *ngIf="isExpanded || isShowing">
						<input type="search" class="form-control search-left-menu" [(ngModel)]="searchtext"
							(keyup.enter)="golink()" placeholder="PNR Search" />
					</span><mat-icon mat-list-icon style="position: absolute !important; right:10px;"
						(click)="golink()">search</mat-icon>
				</mat-list-item>

				<a href="" [routerLink]="['/master/inventory-one-way']">
					<mat-list-item [routerLinkActive]="['active3']" class="mt-1">
						<span class="full-width" *ngIf="isExpanded || isShowing">Inventory</span>
						<mat-icon mat-list-icon>dashboard</mat-icon>
					</mat-list-item>
				</a>

				<a href="" [routerLink]="['/dashboard/accounting/sale']" >
					<mat-list-item [routerLinkActive]="['active3']" class="mt-1" [ngClass]="{'theme1': clrCode1, 'theme2':clrCode2, 'theme3':clrCode3, 'theme4':clrCode4, 'theme5':clrCode5 }">
						<span class="full-width" *ngIf="isShowing || isExpanded">Sale</span>
						<mat-icon mat-list-icon>book</mat-icon>
					</mat-list-item>
				</a>


				<a href="" [routerLink]="['/dashboard/myapi-balance']" >
					<mat-list-item [routerLinkActive]="['active3']" class="mt-1">
						<span class="full-width" *ngIf="isExpanded || isShowing">My Account</span>
						<mat-icon mat-list-icon>api</mat-icon>
					</mat-list-item>
				</a>


			</mat-nav-list>
		</mat-sidenav> -->
        <div class="example-sidenav-content">
            <router-outlet *ngIf="!user"></router-outlet>

            <div [ngClass]="isFullWidthPage ? 'container-fluid p-0' : 'container mt-3'" *ngIf="user">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-sidenav-container>
</div>
<!-- Change Website setting modal start -->
<div class="modal fade" id="web_set" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">×</span></button>
                <div class="col-md-12 p-0">
                    <h4 class="modal-title" style="text-align: center;">Website Setting</h4>
                </div>
            </div>
            <div class="modal-body">
                <div class="row p-4">
                    <table class="table w-100 m-0 table-bordered">
                        <tbody>
                            <tr>
                                <td>B2C Login</td>
                                <td>
                                    <span class="cursorp">
                                        <label class="switch mb-0">
                                            <input type="checkbox" [checked]="b2c_login == true"
                                                (click)="b2c_onOff($event.target.checked)" />
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Book Outside</td>
                                <td>
                                    <span class="cursorp">
                                        <label class="switch mb-0">
                                            <input type="checkbox" [checked]="book_outside == true"
                                                (click)="book_outside_onOff($event.target.checked)" />
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Show Outside</td>
                                <td>
                                    <span class="cursorp">
                                        <label class="switch mb-0">
                                            <input type="checkbox" [checked]="show_outside == true"
                                                (click)="show_onOff($event.target.checked)" />
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Scroll Message Inside</td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="scroll_msg_inside" />
                                </td>
                            </tr>
                            <tr>
                                <td>Scroll Message Outside</td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="scroll_msg_outside" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer text-right border-top d-inline-block">
                <button type="button" class="btn btn-success btn-sm" *ngIf="Enable_set_var == true"
                    (click)="Enable_set()">Enable Settings</button>
                <button class="btn btn-sm btn-primary"
                    [disabled]="((scroll_msg_inside == '' || scroll_msg_inside == null) && (scroll_msg_outside == '' || scroll_msg_outside == null )) "
                    (click)="Edit_setting()">Save Setting</button>
                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Change Website setting modal end -->


<ngx-ui-loader></ngx-ui-loader>

<app-footer>

</app-footer>